import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import { Card } from '@iris/react-components/Card';
import clsx from 'clsx';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

import { useDevice } from '@bonnet/next/device';

import { Image, Link } from 'reaxl';

import getPathSRP from '@/utilities/getPathSRP';

import queryDuck from '@/ducks/queryDuck.js';

// Commercial SRP Entry Point Filter Component
function CommercialSrpFilterEntryPoint({
    className = '',
    icon,
    onCommercialEntryPointClick = () => { },
}) {

    const device = useDevice();
    const isMd = _get(device, 'is.md', false);

    const query = useSelector(queryDuck.selectors.getDuckState);
    const [commercialPath, setCommercialPath] = useState('');

    useEffect(() => {
        const commercialQuery = { ...query };

        delete commercialQuery.makeCode;
        delete commercialQuery.modelCode;
        delete commercialQuery.trimCode;
        delete commercialQuery.vehicleStyleCode;
        delete commercialQuery.zip;
        delete commercialQuery.state;
        delete commercialQuery.city;

        const generateCommercialSrpPath = async () => {
            const path = await getPathSRP({ ...commercialQuery, experience: 'commercial' }, { basePath: true });
            setCommercialPath(path);
        };

        if (!_isEmpty(commercialQuery)) {
            generateCommercialSrpPath();
        }
    }, [query]);

    return (
        <div
            className={className}
            data-cmp="commercial-srp-filter-entry-point"
        >
            <Card
                variant="brand-subtle"
                className="align-items-center"
            >
                <Card.Content className={clsx('display-flex align-items-center', {
                    'flex-column': isMd,
                })}
                >
                    <Link href={commercialPath}>
                        <Image
                            alt="commercial-vehicle-image"
                            className="cursor-pointer"
                            data-cmp="commercial-srp-entry-point-icon"
                            onClick={onCommercialEntryPointClick}
                            src={icon}
                            width="64"
                        />
                    </Link>
                    <Link
                        data-cmp="commercial-srp-entry-point-link"
                        href={commercialPath}
                        className={clsx('text-link link-undecorated', {
                            'padding-left-2': !isMd,
                        })}
                        onClick={onCommercialEntryPointClick}
                    >
                        Shop commercial
                    </Link>
                </Card.Content>
            </Card>
        </div>
    );
}

export default CommercialSrpFilterEntryPoint;
